module.exports = __webpack_public_path__ + "static/media/FM.5f418bd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/FM.svg
// module id = 2152
// module chunks = 7